import { render } from "./Thanks.vue?vue&type=template&id=11607f13"
const script = {}

import exportComponent from "/home/alan-liang/Code/misc/GGJ22/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__